import React, { useState, useEffect } from 'react';
import { List, ListItem, ListItemText, Checkbox } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';

// Función para combinar módulos con el mismo id_modulo
const combinarModulosDuplicados = (modulos) => {
    const modulosMap = {};

    modulos.forEach(modulo => {
        if (!modulosMap[modulo.id_modulo]) {
            modulosMap[modulo.id_modulo] = { ...modulo, submodulos: [...modulo.submodulos] };
        } else {
            modulosMap[modulo.id_modulo].submodulos.push(...modulo.submodulos);
        }
    });

    return Object.values(modulosMap);
};

const ListaModulos = ({ catalogoModulos, isEditing, modulosSeleccionados }) => {
    // Fusionamos los módulos duplicados antes de usarlos
    const modulosUnicos = combinarModulosDuplicados(catalogoModulos);

    const [seleccionados, setSeleccionados] = useState(() => {
        const saved = localStorage.getItem('seleccionados');
        return saved ? JSON.parse(saved) : [];
    });

    useEffect(() => {
        setSeleccionados(modulosSeleccionados);
    }, [modulosSeleccionados]);

    useEffect(() => {
        localStorage.setItem('seleccionados', JSON.stringify(seleccionados));
    }, [seleccionados]);

    const isModuloSeleccionado = (idModulo) => {
        return seleccionados.some(modulo => modulo.idModulo === idModulo);
    };

    const isSubmoduloSeleccionado = (idModulo, idSubmodulo) => {
        const modulo = seleccionados.find(modulo => modulo.idModulo === idModulo);
        return modulo ? modulo.submodulos.includes(idSubmodulo) : false;
    };

    const handleModuloChange = (idModulo) => {
        setSeleccionados(prevSeleccionados => {
            if (isModuloSeleccionado(idModulo)) {
                return prevSeleccionados.filter(modulo => modulo.idModulo !== idModulo);
            } else {
                return [...prevSeleccionados, { idModulo, submodulos: [] }];
            }
        });
    };

    const handleSubmoduloChange = (idModulo, idSubmodulo) => {
        setSeleccionados(prevSeleccionados => {
            const modulo = prevSeleccionados.find(modulo => modulo.idModulo === idModulo);
            if (modulo) {
                const submodulosActualizados = modulo.submodulos.includes(idSubmodulo)
                    ? modulo.submodulos.filter(sub => sub !== idSubmodulo)
                    : [...modulo.submodulos, idSubmodulo];

                return prevSeleccionados.map(m =>
                    m.idModulo === idModulo ? { ...m, submodulos: submodulosActualizados } : m
                );
            } else {
                return [...prevSeleccionados, { idModulo, submodulos: [idSubmodulo] }];
            }
        });
    };

    const validationSchema = Yup.object().shape({
        seleccionados: Yup.array().min(1, 'Debe seleccionar al menos un módulo o submódulo')
    });

    const formik = useFormik({
        initialValues: { seleccionados },
        validationSchema,
        onSubmit: (values) => {
            console.log('Formulario válido:', values);
        }
    });

    useEffect(() => {
        formik.setFieldValue('seleccionados', seleccionados);
    }, [seleccionados]);

    return (
        <form onSubmit={formik.handleSubmit}>
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <List>
                    {modulosUnicos.map(modulo => (
                        <div key={modulo.id_modulo}>
                            <ListItem style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #ddd', padding: '10px 20px' }}>
                                <Checkbox
                                    checked={isModuloSeleccionado(modulo.id_modulo)}
                                    onChange={() => handleModuloChange(modulo.id_modulo)}
                                />
                                <ListItemText primary={modulo.nombre_modulo} />
                            </ListItem>
                            {modulo.submodulos.length > 0 && (
                                <List component="div" disablePadding>
                                    {modulo.submodulos.map(submodulo => (
                                        <ListItem
                                            key={submodulo.id_submodulo}
                                            style={{ backgroundColor: '#fafafa', borderBottom: '1px solid #ddd', padding: '10px 40px' }}
                                        >
                                            <Checkbox
                                                checked={isSubmoduloSeleccionado(modulo.id_modulo, submodulo.id_submodulo)}
                                                onChange={() => handleSubmoduloChange(modulo.id_modulo, submodulo.id_submodulo)}
                                            />
                                            <ListItemText primary={submodulo.nombre_submodulo} />
                                        </ListItem>
                                    ))}
                                </List>
                            )}
                        </div>
                    ))}
                </List>
            </div>
            {formik.errors.seleccionados && <div style={{ color: 'red' }}>{formik.errors.seleccionados}</div>}
        </form>
    );
};

export default ListaModulos;